import React from "react";

import useAdminListItems from "../hooks/useAdminListItems";
import AdminItems from "../components/AdminListItems";

export default function AdminListItemsInterface(props) {
  const { onEdit, businessType, onEdit2 } = props;
  const {
    items,
    merchants,
    menu,
    superUser,
    onDelete,
    onRefreshData,
    apiError,
  } = useAdminListItems();

  return (
    <AdminItems
      businessType={businessType}
      superUser={superUser}
      items={items}
      merchants={merchants}
      menu={menu}
      onDelete={onDelete}
      apiError={apiError}
      onEdit={onEdit}
      onRefreshData={onRefreshData}
      onEdit2={onEdit2}
    />
  );
}
